import SockJS from 'sockjs-client'
import { Client } from '@stomp/stompjs'

import { getToken } from '@/utils/auth'

const Websocket = () => {
  // 请求的起始地址，根据开发环境变量确定

  const stompClient = new Client({
    // 可以不赋值，因为后面用SockJS来代替
    // brokerURL: 'ws://localhost:9527/dev-api/ws/',
    // 获得客户端token的方法，把token放到请求头中
    connectHeaders: { 'Authorization': getToken() },
    debug: function (str) {
      // debug日志，调试时候开启
      console.log(str)
    },
    reconnectDelay: 10000, // 重连时间
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000
  })
  // //用SockJS代替brokenURL
  stompClient.webSocketFactory = function () {
    // 因为服务端监听的是/ws路径下面的请求，所以跟服务端保持一致
    return new SockJS(`${process.env.VUE_APP_BASE_WEBSOCKET_API}/accountws/hmzh`, null, {
      timeout: 10000
    })
  }
  return {
    stompClient: stompClient,
    connect(callback) {
      // 连接
      stompClient.onConnect = (frame) => {
        callback(frame)
      }
      // 错误
      stompClient.onStompError = function (frame) {
        console.log('Broker reported error: ' + frame.headers['message'])
        console.log('Additional details: ' + frame.body)
        // 这里不需要重连了，新版自带重连
      }
      // 启动
      stompClient.activate()
    },
    close() {
      if (this.stompClient !== null) {
        this.stompClient.deactivate()
      }
    },
    // 发送消息
    send(addr, msg) {
      // 添加app的前缀，并发送消息，publish是新版的stomp/stompjs发送api，老版本更改下就可以。
      this.stompClient.publish({
        destination: '/app' + addr,
        body: msg
      })
    },
    // 订阅消息
    subscribe(addr, callback) {
      this.stompClient.subscribe(addr, (res) => {
        // 这里进行了JSON类型的转化，因为我的服务端返回的数据都是json，消息本身是string型的，所以进行了转化。
        var result = JSON.parse(res.body)
        callback(result)
      })
    }
  }
}
export default Websocket
